module.exports = __webpack_public_path__ + "static/media/narwhal.9a751dbe.svg";